import { z } from "zod/v4";

export const PostCustomShippingRateRequestBodySchema = z.object({
  shopId: z.string(),
  performingUserEmail: z.string().optional(),
  rateDescription: z.string(),
});
export type PostCustomShippingRateRequestBodyType = z.infer<
  typeof PostCustomShippingRateRequestBodySchema
>;

export const PostCustomShippingRateRequestPathParamSchema = z.object({
  experienceId: z.uuid(),
});
export type PostCustomShippingRateRequestPathParamType = z.infer<
  typeof PostCustomShippingRateRequestPathParamSchema
>;
